import jsPDF from 'jspdf'
import 'jspdf-autotable'
import moment from 'moment'
import {
  wtFormatMoney,
  wtFormatMoneyRoundData,
  wtRoundNumberToSpecifedDigits,
  wtRoundValue,
} from 'src/helpers/commons/utils'
import QRCode from 'qrcode'
import { FRONT_BASE_URL } from 'src/config/Request'
import { wtGetFromLocalStorage } from 'src/helpers/commons/LocalStorage'

export const OtFormSalary = (record, monthYear, ot_form, isLockedForm = 0, reportView = 0) => {
  const bodyRows = (data) => {
    const gapHeight = 10
    var body = []
    if (isLockedForm === 0) {
      data.map((item, index) => {
        body.push([
          item.attendance_date,
          item.type,
          // moment(item.attendance_date).format('dddd'),
          item.updated_check_in ? item.updated_check_in : item.check_in,
          item.updated_check_out ? item.updated_check_out : item.check_out,
          wtRoundNumberToSpecifedDigits(
            item.updated_working_hours ? item.updated_working_hours : item.working_hours,
          ),
          // wtRoundNumberToSpecifedDigits(item.overtime_hours),
          wtRoundNumberToSpecifedDigits(
            item.is_overtime_approved ? item.updated_overtime_hours : 0,
          ),
          // item.updated_type ? item.updated_type : item.type,
          index % 7 === 0
            ? { content: 'Bonus Content', rowSpan: 7, styles: { halign: 'center' } }
            : '',

          item.overtime_remarks ? item.overtime_remarks : '',
        ])
      })
    } else {
      data.map((item, index) => {
        body.push([
          item.attendance_date,
          item.type,
          // moment(item.attendance_date).format('dddd'),
          item.check_in ? item.check_in : '',
          item.check_out ? item.check_out : '',
          wtRoundNumberToSpecifedDigits(item.working_hours ? item.working_hours : ''),
          // wtRoundNumberToSpecifedDigits(item.overtime_hours),
          wtRoundNumberToSpecifedDigits(item.is_overtime_approved ? item.original_overtime_hours : 0),

          index % 7 === 0
            ? {
              content: item.bonus_hours ? item.bonus_hours : '-',
              rowSpan: 7,
              styles: { halign: 'center', valign: 'middle' },
            }
            : '',
          item.overtime_remarks ? item.overtime_remarks : '',
        ])
      })
    }
    return body
  }

  const summaryBody = () => {
    const gapHeight = 10
    var body = []

    let total_original_overtime_hours = 0
    let total_bonus_hours = 0
    let total_overtime_amount = 0
    record.map((item, index) => {
      if (!item.cancelled_at) {
        total_original_overtime_hours += item.total_original_overtime_hours
        total_bonus_hours += item.total_bonus_hours ? parseFloat(item.total_bonus_hours) : 0
        total_overtime_amount += item.overtime_amount
        body.push([
          index + 1,
          item.id,
          { content: item.full_name, styles: { halign: 'left' } },
          item.department.name,
          item.designation.name,
          item.basic_salary ? wtFormatMoneyRoundData(item.basic_salary, "") : '-',
          {
            content: item.total_original_overtime_hours ? wtRoundValue(item.total_original_overtime_hours) : '-',
            styles: { textColor: 'green' },
          },
          item.total_bonus_hours ? wtRoundValue(item.total_bonus_hours) : '-',
          {
            content: item.overtime_amount ? wtFormatMoneyRoundData(item.overtime_amount) : '-',
            styles: { textColor: 'blue' },
          },
        ])
      }
    })

    body.push([
      {
        content: 'Total',
        colSpan: 8,
        styles: { halign: 'center', fontStyle: 'bold' },
      },

      {
        content: total_overtime_amount ? wtFormatMoneyRoundData(total_overtime_amount, '') : '-',
        styles: { textColor: 'blue' },
      },
    ])

    return body
  }

  const watermarkText = 'DRAFT'
  const watermarkFontSize = 100

  const doc = new jsPDF()
  const pageWidth = doc.internal.pageSize.width
  const logo = 'assets/wil-icon.png'
  let yPosition = 50

  // Function to add logo and header to all pages
  const addLogoToAllPages = () => {
    const pageCount = doc.internal.getNumberOfPages()
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i)
      doc.setTextColor('#3c4b64')
      doc.setFont('Helvetica', 'bold')

      const pageWidth = doc.internal.pageSize.width
      doc.setTextColor('#3c4b64')
      doc.setFont('Helvetica', 'bold') //Header middle branch logo

      doc.addImage(logo, 'PNG', pageWidth - 200, 4, 25, 25)
      doc.line(pageWidth - 173, 7, pageWidth - 173, 27) // Adjust the coordinates as needed

      doc.setFontSize(11)
      doc.text('WAH', pageWidth - 171, 10, { align: 'left' })
      doc.setFontSize(11)
      doc.setFont('Helvetica')
      doc.text('INDUSTRIES', pageWidth - 171, 15)
      doc.text('LIMITED', pageWidth - 171, 20)
      doc.setFontSize(9)
      doc.text('www.wahindustries.com', pageWidth - 171, 25)
      doc.setTextColor('#000000')
      doc.setFont('Helvetica', 'bold')
      doc.setFontSize(12)
      doc.text('OVERTIME FORM', pageWidth - 12, 10, { align: 'right' })

      const qrCodeSize = 24
      const qrCodeX = (pageWidth - qrCodeSize) / 2
      const qrCodeY = 4

      const qrCodeText = FRONT_BASE_URL
      QRCode.toDataURL(qrCodeText, { width: qrCodeSize }, (err, url) => {
        if (err) {
          console.error(err)
        } else {
          doc.addImage(url, 'PNG', qrCodeX, qrCodeY, qrCodeSize, qrCodeSize)
        }
      })
    }
  }

  doc.setFontSize(15)
  doc.setTextColor('#3c4b64')
  doc.setFont('Helvetica', 'bold')
  doc.text(
    `Overtime Summary for the Month of ${moment(monthYear, 'YYYY-MM').format('MMMM YYYY')}`,
    pageWidth - 103,
    40,
    { align: 'center' },
  )

  doc.setFont('helvetica', 'normal')
  doc.setTextColor('Black')
  doc.setFontSize(12)
  function drawLine(x1, y1, x2, y2) {
    doc.moveTo(x1, y1).lineTo(x2, y2).stroke()
  }
  const lineHeight = 1

  doc.text(`Batch ID:`, 16, 47.5, { align: 'left' })
  doc.setTextColor('#0202f7')
  doc.text(`${ot_form.id}`, 41, 47.5, {
    align: 'left',
  })
  const BatchIdWidth = 50
  const BatchIdLineStartX = 39
  const BatchIdLineStartY = 47.5
  const BatchIdLineEndX = BatchIdLineStartX + BatchIdWidth
  const BatchIdLineEndY = BatchIdLineStartY
  drawLine(
    BatchIdLineStartX,
    BatchIdLineStartY + lineHeight,
    BatchIdLineEndX,
    BatchIdLineEndY + lineHeight,
  )

  doc.setFont('helvetica', 'normal')
  doc.setTextColor('Black')
  doc.text(`Created By:`, 98, 47.5, { align: 'left' })
  doc.setTextColor('#0202f7')
  doc.text(`${ot_form.created_by ? ot_form.created_by.name : ''}`, 125, 47.5, {
    align: 'left',
  })
  const CreatedByWidth = 72
  const CreatedByLineStartX = 123
  const CreatedByLineStartY = 47.5
  const CreatedByLineEndX = CreatedByLineStartX + CreatedByWidth
  const CreatedByLineEndY = CreatedByLineStartY
  drawLine(
    CreatedByLineStartX,
    CreatedByLineStartY + lineHeight,
    CreatedByLineEndX,
    CreatedByLineEndY + lineHeight,
  )

  const OvertimeSummaryTable = [
    [
      { content: 'Sr', styles: { fontStyle: 'bold', halign: 'center', width: 5 } },
      { content: 'ID', styles: { fontStyle: 'bold', halign: 'center', width: 5 } },
      { content: 'Full Name', styles: { fontStyle: 'bold', halign: 'center', width: 20 } },
      { content: 'Department', styles: { fontStyle: 'bold', halign: 'center', width: 10 } },
      { content: 'Designation', styles: { fontStyle: 'bold', halign: 'center', width: 10 } },
      { content: 'Basic Pay', styles: { fontStyle: 'bold', halign: 'center', width: 10 } },
      { content: 'Overtime Hours', styles: { fontStyle: 'bold', halign: 'center', width: 10 } },
      { content: 'Bonus Hours', styles: { fontStyle: 'bold', halign: 'center', width: 10 } },
      { content: 'Amount', styles: { fontStyle: 'bold', halign: 'center', width: 10 } },
    ],
  ]

  const tableTopMargin = 35

  doc.autoTable({
    startY: yPosition,
    margin: { top: tableTopMargin, left: 10 },
    head: OvertimeSummaryTable,
    body: summaryBody(),
    theme: 'plain',
    tableLineColor: '#3c4b64',
    tableLineWidth: 0.2,
    tableWidth: 190,
    headStyles: { fillColor: [217, 218, 219] },
    styles: {
      lineColor: '#3c4b64',
      lineWidth: 0.2,
      halign: 'center',
      font: 'helvetica',
    },
    didDrawPage: function (data) { },
  })

  const Table3 = [
    [
      {
        content:
          '_______________________\t\t\t_______________________\t\t\t_______________________',
        styles: { halign: 'left', fontStyle: 'bold' },
      },
    ],
    [
      {
        content: '\tSr. Manager F&A\t\t\t\t\t   CFO & Secy WIL\t\t\t\t\t   CEO & MD-WIL',
        styles: { halign: 'left', fontStyle: 'bold' },
      },
    ],
  ]

  const gapBetweenTable23 = 15
  const startYForTable23 = doc.autoTable.previous.finalY + gapBetweenTable23
  doc.autoTable({
    startY: startYForTable23,
    margin: { top: 20 },
    body: Table3, // Body rows for second table
    theme: 'plain',
    tableLineColor: '#ffffff',
    tableLineWidth: 0,
    tableWidth: 'auto', // Set table width automatically
    styles: {
      lineColor: '#ffffff',
      lineWidth: 0,
      halign: 'center',
      font: 'helvetica',
      cellPadding: { top: 0.1, right: 0.1, bottom: 0.1, left: 0.1 },
    },
    didDrawPage: function (data) { },
  })

  addLogoToAllPages()

  doc.addPage()

  record.map((pdfData) => {
    if (isLockedForm === 0) {
      doc.setTextColor(255, 145, 145) // Set the color of the watermark text
      doc.setFont('Helvetica', 'bold') //Header middle branch logo
      doc.setFontSize(watermarkFontSize)
      doc.text(130, 200, watermarkText, null, 45, 'center')
    }

    if (pdfData.cancelled_at !== 0 && reportView === 0) {
      doc.setTextColor(255, 145, 145) // Set the color of the watermark text
      doc.setFont('Helvetica', 'bold') //Header middle branch logo
      doc.setFontSize(watermarkFontSize)
      doc.text(140, 200, 'CANCELLED', null, 45, 'center')
    }

    doc.setTextColor('#3c4b64')
    doc.setFont('Helvetica', 'bold') //Header middle branch logo

    doc.addImage(logo, 'PNG', pageWidth - 200, 4, 25, 25)
    doc.line(pageWidth - 173, 7, pageWidth - 173, 27) // Adjust the coordinates as needed

    doc.setFontSize(11)
    doc.text('WAH', pageWidth - 171, 10, { align: 'left' })
    doc.setFontSize(11)
    doc.setFont('Helvetica')
    doc.text('INDUSTRIES', pageWidth - 171, 15)
    doc.text('LIMITED', pageWidth - 171, 20)
    doc.setFontSize(9)
    doc.text('www.wahindustries.com', pageWidth - 171, 25)

    doc.setTextColor('#000000') // Set text color to black
    doc.setFont('Helvetica', 'bold')
    doc.setFontSize(12)
    const label = 'OVERTIME FORM'
    doc.text(label, 150, 10, { align: 'left' })

    const qrCodeSize = 24
    const qrCodeX = (pageWidth - qrCodeSize) / 2
    const qrCodeY = 4

    const qrCodeText = FRONT_BASE_URL + 'employee-profile?id=1' + pdfData.id
    QRCode.toDataURL(qrCodeText, { width: qrCodeSize }, (err, url) => {
      if (err) {
        console.error(err)
      } else {
        doc.addImage(url, 'PNG', qrCodeX, qrCodeY, qrCodeSize, qrCodeSize)
      }
    })

    doc.setFont('helvetica', 'normal')
    doc.setTextColor('Black')

    doc.setFontSize(12)

    doc.text(`ID:`, 16, 32.5, { align: 'left' })
    doc.text(`${pdfData.id ? pdfData.id : ''}`, 25, 32.5, { align: 'left' })

    const textWidth = 23
    function drawLine(x1, y1, x2, y2) {
      doc.moveTo(x1, y1).lineTo(x2, y2).stroke()
    }

    const lineHeight = 1
    drawLine(23, 32.5 + lineHeight, 23 + textWidth, 32.5 + lineHeight)

    doc.text('Personal File No:', 47, 32.5, { align: 'left' })
    doc.text(`${pdfData.personal_file_no ? pdfData.personal_file_no : ''}`, 83, 32.5, {
      align: 'left',
    })

    const PersonalFileNoWidth = 32.5

    const lineStartX1 = 81
    const lineStartY1 = 32.5
    const lineEndX1 = lineStartX1 + PersonalFileNoWidth
    const lineEndY1 = lineStartY1

    drawLine(lineStartX1, lineStartY1 + lineHeight, lineEndX1, lineEndY1 + lineHeight)

    doc.text('Name:', 117, 32.5, { align: 'left' })
    doc.text(`${pdfData.full_name ? pdfData.full_name : ''}`, 133, 32.5, {
      align: 'left',
    })

    const NameWidth = 59

    const lineStartX = 132
    const lineStartY = 32.5
    const lineEndX = lineStartX + NameWidth
    const lineEndY = lineStartY

    drawLine(lineStartX, lineStartY + lineHeight, lineEndX, lineEndY + lineHeight)

    doc.text(`Designation:`, 16, 40.5, { align: 'left' })
    doc.text(`${pdfData.designation ? pdfData.designation.name : ''}`, 43, 40.5, {
      align: 'left',
    })

    const DesignationWidth = 54

    const DesignationLineStartX = 40.5
    const DesignationLineStartY = 40.5
    const DesignationLineEndX = DesignationLineStartX + DesignationWidth
    const DesignationLineEndY = DesignationLineStartY

    drawLine(
      DesignationLineStartX,
      DesignationLineStartY + lineHeight,
      DesignationLineEndX,
      DesignationLineEndY + lineHeight,
    )

    doc.text(`Department:`, 98, 40.5, { align: 'left' })
    doc.text(`${pdfData.department ? pdfData.department.name : ''}`, 125, 40.5, {
      align: 'left',
    })

    const DepartmentWidth = 72

    const DepartmentLineStartX = 123
    const DepartmentLineStartY = 40.5
    const DepartmentLineEndX = DepartmentLineStartX + DepartmentWidth
    const DepartmentLineEndY = DepartmentLineStartY

    drawLine(
      DepartmentLineStartX,
      DepartmentLineStartY + lineHeight,
      DepartmentLineEndX,
      DepartmentLineEndY + lineHeight,
    )

    doc.text(`Basic Pay:`, 16, 47.5, { align: 'left' })
    doc.setTextColor('#0202f7')
    doc.text(
      `${pdfData.basic_salary ? wtFormatMoneyRoundData(pdfData.basic_salary, '', false) : ''}`,
      41,
      47.5,
      {
        align: 'left',
      },
    )

    const BasicPayWidth = 50

    const BasicPayLineStartX = 39
    const BasicPayLineStartY = 47.5
    const BasicPayLineEndX = BasicPayLineStartX + BasicPayWidth
    const BasicPayLineEndY = BasicPayLineStartY

    drawLine(
      BasicPayLineStartX,
      BasicPayLineStartY + lineHeight,
      BasicPayLineEndX,
      BasicPayLineEndY + lineHeight,
    )

    let Table1 = [
      [
        {
          content: 'Date',
          styles: { fontStyle: 'bold', halign: 'center', cellWidth: 22 },
        },
        // { content: 'Day', styles: { fontStyle: 'bold', halign: 'center', cellWidth: 20 } },
        {
          content: 'Type',
          styles: { fontStyle: 'bold', halign: 'center', cellWidth: 21 },
        },
        { content: 'Check In', styles: { fontStyle: 'bold', halign: 'center', cellWidth: 18 } },
        { content: 'Check Out', styles: { fontStyle: 'bold', halign: 'center', cellWidth: 18 } },
        {
          content: 'Working Hours',
          styles: { fontStyle: 'bold', halign: 'center', cellWidth: 18 },
        },
        {
          content: 'Approved Overtime Hours',
          styles: { fontStyle: 'bold', halign: 'center', cellWidth: 20 },
        },
        {
          content: 'Bonus Hours',
          styles: { fontStyle: 'bold', halign: 'center', cellWidth: 25 },
        },
        {
          content: 'Remarks',
          styles: { fontStyle: 'bold', halign: 'center', cellWidth: 40 },
        },
      ],

      // ['2024-02-01', 'Monday', '2', 'Present'],
      // ['2024-02-02', 'Tuesday', '3', 'Present'],
    ]

    doc.autoTable({
      startY: yPosition,
      margin: { top: 20 },
      head: Table1,
      body: bodyRows(pdfData.attendances),
      // foot: [
      //   [
      //     {
      //       content: 'Total Overtime',
      //       colSpan: 5,
      //       styles: { halign: 'center', fontStyle: 'bold' },
      //     },
      //     {
      //       content: wtRoundNumberToSpecifedDigits(pdfData.total_overtime_hours),
      //       styles: { textColor: 'blue' },
      //     },
      //   ],
      // ],
      theme: 'plain',
      tableLineColor: '#3c4b64',
      tableLineWidth: 0.2,
      tableWidth: 'auto',
      headStyles: { fillColor: [217, 218, 219] },
      styles: {
        lineColor: '#3c4b64',
        lineWidth: 0.2,
        halign: 'center',
        font: 'helvetica',
        cellPadding: { top: 0.5, right: 0.5, bottom: 0.5, left: 0.5 },
      },
      didDrawPage: function (data) { },
    })

    const singleRowTable = [
      [
        {
          content: 'Total Overtime',
          styles: { fontStyle: 'bold', halign: 'center', cellWidth: 97 },
        },
        {
          content: wtRoundNumberToSpecifedDigits(pdfData.total_original_overtime_hours),
          styles: { fontStyle: 'bold', halign: 'center', cellWidth: 20 },
        },
        {
          content: wtRoundNumberToSpecifedDigits(pdfData.total_bonus_hours),
          styles: { fontStyle: 'bold', halign: 'center', cellWidth: 25 },
        },
        { content: '', styles: { fontStyle: 'bold', halign: 'center', cellWidth: 40 } },
        // { content: '', styles: { fontStyle: 'bold', halign: 'center', cellWidth: 25 } },
      ],
    ]

    doc.autoTable({
      startY: doc.autoTable.previous.finalY + 0, // Adjust startY to position the new table below Table 1
      margin: { top: 20 },
      head: singleRowTable,
      theme: 'plain',
      tableLineColor: '#3c4b64',
      tableLineWidth: 0.2,
      tableWidth: 'auto',
      // headStyles: { fillColor: 'white' },
      styles: {
        lineColor: '#3c4b64',
        lineWidth: 0.2,
        halign: 'center',
        font: 'helvetica',
        cellPadding: { top: 0.5, right: 0.5, bottom: 0.5, left: 0.5 },
      },
      didDrawPage: function (data) { },
    })

    const Table2 = [
      [
        {
          content: 'For Accounts Department',
          styles: { halign: 'center', fontStyle: 'bold', fontSize: 10 },
        },
      ],
    ]

    const gapBetweenTable231 = 1
    const startYForTable231 = doc.autoTable.previous.finalY + gapBetweenTable231

    drawLine(35, startYForTable231 + 12, 100, startYForTable231 + 12)
    doc.setTextColor('black')
    doc.text(`Rate (Rs) :`, 14, startYForTable231 + 11, { align: 'left' })
    doc.setTextColor('#0202f7')
    doc.text(
      `${pdfData.overtime_rate ? wtFormatMoneyRoundData(pdfData.overtime_rate, '', false) : ''}`,
      35,
      startYForTable231 + 11,
      { align: 'left' },
    )

    drawLine(130, startYForTable231 + 12, 196, startYForTable231 + 12)
    doc.setTextColor('black')
    doc.text(`Amount (Rs) :`, 103, startYForTable231 + 11, { align: 'left' })
    doc.setTextColor('#0202f7')
    doc.text(
      `${pdfData.overtime_amount ? wtFormatMoneyRoundData(pdfData.overtime_amount, '', false) : ''
      }`,
      130,
      startYForTable231 + 11,
      { align: 'left' },
    )

    drawLine(47, startYForTable231 + 20, 196, startYForTable231 + 20)
    doc.setTextColor('black')
    doc.text(`Amount In Word :`, 14, startYForTable231 + 19, { align: 'left' })
    doc.setTextColor('#0202f7')
    doc.text(`${pdfData.amount_in_words + ' Rupees Only'}`, 49, startYForTable231 + 19, {
      align: 'left',
    })

    // const Table3 = [
    //   [
    //     {
    //       content: '_______________________\t\t\t_______________________\t\t\t_______________________',
    //       styles: { halign: 'left', fontStyle: 'bold' },
    //     },
    //   ],

    //   [
    //     {
    //       content: '\tSr. Manager F&A\t\t\t\t\t   CEO & MD-WIL\t\t\t\t\t   CFO & Secy WIL',
    //       styles: { halign: 'left', fontStyle: 'bold' },
    //     },
    //   ],
    // ]

    const gapBetweenTables = 1
    const startYForTable12 = doc.autoTable.previous.finalY + gapBetweenTables
    doc.autoTable({
      startY: startYForTable12,
      margin: { top: 20 },
      body: Table2, // Body rows for second table
      theme: 'plain',
      tableLineColor: '#ffffff',
      tableLineWidth: 0,
      tableWidth: 'auto', // Set table width automatically
      styles: {
        lineColor: '#ffffff',
        lineWidth: 0,
        halign: 'center',
        font: 'helvetica',
        cellPadding: { top: 0.4, right: 0.4, bottom: 0.4, left: 0.4 },
      },
      didDrawPage: function (data) { },
    })

    const gapBetweenTable23 = 1
    const startYForTable23 = doc.autoTable.previous.finalY + gapBetweenTable23

    // doc.autoTable({
    //   startY: startYForTable23,
    //   margin: { top: 20 },
    //   body: Table3, // Body rows for second table
    //   theme: 'plain',
    //   tableLineColor: '#ffffff',
    //   tableLineWidth: 0,
    //   tableWidth: 'auto', // Set table width automatically
    //   styles: {
    //     lineColor: '#ffffff',
    //     lineWidth: 0,
    //     halign: 'center',
    //     font: 'helvetica',
    //     cellPadding: { top: 0.1, right: 0.1, bottom: 0.1, left: 0.1 },
    //   },
    //   didDrawPage: function (data) { },
    // })

    doc.addPage()
  })

  const user = wtGetFromLocalStorage("authUser");
  const addFooter = (doc) => {
    const pageCount = doc.internal.getNumberOfPages()
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i)
      doc.setFont('Helvetica', 'bold')
      doc.setTextColor('black')
      doc.setFontSize(9)

      const lineHeight = 286
      const lineWidth = 182
      const lineX = 14
      const lineY = lineHeight
      doc.line(lineX, lineY, lineX + lineWidth, lineY)
      doc.text(`Page ${i} / ${pageCount}`, 190, 290, { align: 'right' })
      doc.text(`Printed By `, 20, 290, { align: 'left' })
      doc.setTextColor('blue')
      doc.text(`${user ? user.name : ''}`, 37, 290, { align: 'left' })
    }
  }
  addFooter(doc)
  // doc.save('OvertimeForm.pdf')
  const pdfBlob = doc.output('blob')
  const pdfUrl = URL.createObjectURL(pdfBlob)
  window.open(pdfUrl, '_blank')
}
